import { GhgKategorieAuswahl } from '../assistent/items/custom/GhgKategorieAuswahl';
import { IDs } from '../../../helpers/IDs';
import * as React from 'react';

export function getExtraFormElementCo2Scope3(entity: string, item: any, data: any, WFormProps?: any, callback?: (data: any) => void): any {
    const after: any = {};
    const before: any = {};
    data = data || {};
    item = item || {};
    WFormProps = WFormProps || {};

    switch (entity) {
        case IDs.ENT_CO2_SCOPE3_EMITTENTEN: {
            after.name = (
                <GhgKategorieAuswahl
                    data={data}
                    item={item}
                    hideLabels={WFormProps.hideLabels}
                    layout={WFormProps.layout}
                    onValueChange={(value: string) => typeof callback === 'function' && callback({ ghg_kategorie: value })}
                    posFieldsHelpBeginning={WFormProps.posFieldsHelpBeginning}
                    showFieldsHelp={WFormProps.showFieldsHelp}
                    showMode={WFormProps.showMode}
                />
            );
            break;
        }
    }

    return {
        ...(Object.keys(after).length && { extraFormElementAfter: after }),
        ...(Object.keys(before).length && { extraFormElementBefore: before })
    };
}
